import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import md5 from 'crypto-js/md5'

import { initialState } from './model'

import analyticsPages from '../../../constants/analytics'
import { actions as clientActions } from '../client/client'
import { productActions } from '../product/product'
import { LoanConfigInitResponse } from '../../../types'

export const hashPhoneNumber = (phone: string): string => {
  const p = phone.split(' ') // phone format +420 xxxxxx
  return md5(`sc${p[1] ? p[1] : phone}ftw`).toString()
}

const analytics = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setScoringReason: (state, { payload }: PayloadAction<string>) => {
      state.FormState = 'scoring_result'
      state.ScoringResult = payload || 'N/A'
    },
    setScoringOk: (state, { payload }: PayloadAction<LoanConfigInitResponse>) => {
      state.canSend = true

      const ib = payload.canFinishInIB ? 'IB' : 'NOIB'
      const client = payload.canFinishOnline ? 'NTB' : `ETB_${ib}`

      state.ScoringResult = `${client}_${payload.scoringResultCalculation}`
    },
    clearAfterSubmit: state => {
      state.FormState = undefined
      state.TnID = undefined
    },
    setFinish: state => {
      state.FormState = 'finish'
    },
    logPhoneNumber: (state, { payload }: PayloadAction<string>) => {
      state.FormState = 'phone_sent'
      state.TnID = hashPhoneNumber(payload)
    },
    setAnalyticsPage: (state, { payload }: PayloadAction<any | undefined>) => {
      if (payload && analyticsPages[payload]) {
        state.PageName = `Expres pujcka:${analyticsPages[payload]}`
      }
    },
    setCantSend: (state, { payload }: PayloadAction<boolean>) => {
      state.canSend = payload
    },
  },
  extraReducers: {
    [productActions.setDataPreConfigurator.type]: (state, { payload }: PayloadAction<any>) => {
      state.LoanAmount = payload.loanAmount
      state.LoanRpsn = payload.rpsn
      state.LoanTerm = payload.term
    },
    [clientActions.saveClientDataToStore]: (state, { payload }: PayloadAction<any>) => {
      state.LoanAmount = payload.loanAmount || state.LoanAmount
      state.LoanTerm = payload.term || state.LoanTerm
      state.LoanIntRate = payload.primIntRate || state.LoanIntRate
    },
  },
})

export const analyticsActions = analytics.actions

export default analytics.reducer
